import moment from "moment/moment";
import { MOMENT_DATE_FORMAT } from "./config";

export class FoundationDateFormatter {
  format(value: string, format: string): string {
    return value ? moment(value, format).format(MOMENT_DATE_FORMAT) : "---";
  }
}
